import React from 'react';

export enum DAY_TYPES {
  WORKING = 'WORKING',
  HOLIDAY = 'HOLIDAY',
  LEAVE = 'LEAVE',
}

export enum DAY_MARK {
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
}

export type MetricProps = {
  metric?: {
    message?: React.ReactNode;
    value?: React.ReactNode;
    mark?: Nullable<DAY_MARK>;
    date?: string;
  };
  day?: string;
  dayType?: DAY_TYPES;
};

export type MetricsProps = Dictionary<MetricProps[]>;

const SATURDAY = 6;
export const SUNDAY = 0;
export const DAYS_IN_WEEK = 7;

export const isWeekend = (day?: Nullable<number>): boolean =>
  typeof day === 'number' && (day === SUNDAY || day === SATURDAY);
